import {
  ButtonOld,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Typography,
} from 'melp-design/components';
import { Radio, RadioGroup, Stack } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps extends DialogProps {
  onCancelClick: () => void;
  id: string;
  firstName: string;
  onActionClick: (value: string) => void;
}

export const DeleteEmployeeDialog = ({
  onCancelClick,
  id,
  firstName,
  onActionClick,
  ...rest
}: IProps) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState('deactivate');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(e.target.value);
  };

  const isDeleteSelected = selectedValue === 'delete';

  const renderOption = (value: string, label: string, description: string) => (
    <Stack direction="row" alignItems="start" gap="20px">
      <Radio sx={{ margin: '-9px' }} value={value} />
      <Stack>
        <Typography variant="h3" pt="1px" mb="10px">
          {label}
        </Typography>
        <Typography
          variant="p1"
          color="textSecondary"
          whiteSpace="break-spaces"
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );

  const handleActionClick = () => onActionClick(selectedValue);

  return (
    <Dialog aria-labelledby={id} onClose={onCancelClick} {...rest}>
      <DialogTitle>
        {t('employees.sure_to_delete', { employee: firstName })}
      </DialogTitle>
      <DialogContent>
        <RadioGroup value={selectedValue} onChange={handleChange}>
          <Stack gap="30px">
            {renderOption(
              'delete',
              t('actions.delete'),
              t('employees.delete_user_info'),
            )}
            {renderOption(
              'deactivate',
              t('employees.deactivate_user'),
              t('employees.deactivate_user_info'),
            )}
          </Stack>
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <ButtonOld onClick={onCancelClick}>{t('common.cancel')}</ButtonOld>
        {isDeleteSelected ? (
          <ButtonOld
            onClick={handleActionClick}
            variant="contained"
            color="error"
            textColor="white"
          >
            {t('actions.delete')}
          </ButtonOld>
        ) : (
          <ButtonOld
            onClick={handleActionClick}
            variant="contained"
            color="primary"
          >
            {t('employees.deactivate_user')}
          </ButtonOld>
        )}
      </DialogActions>
    </Dialog>
  );
};
